import { MULTI_LINE_DISCOUNT_VALIDATION_ID } from 'views/auto_form/constants';

const requiresPropertyBinderNumber = (
  validations: Validation | Validation[] | undefined | null,
): boolean => {
  const validation = Array.isArray(validations)
    ? validations.find(
        (v) => v.validation_id === MULTI_LINE_DISCOUNT_VALIDATION_ID,
      )
    : validations;

  return (
    validation?.validation_outcome_data?.requires_property_binder_number ===
    true
  );
};

export default requiresPropertyBinderNumber;
